import { _axios } from './service'

export interface IFeatureFlags {
  budget_module_enabled: boolean
  department_api_enabled: boolean
  enable_budget_module: boolean
  enable_restricted_access_mode: boolean
  restricted_features: {
    dashboard?: boolean
    projects?: boolean
    time_tracking?: boolean
    accounting?: boolean
    reports?: boolean
    notifications?: boolean
  }
}

export const featureFlagsApi = {
  getFeatureFlags: async (): Promise<IFeatureFlags> => {
    const response = await _axios.get('/api/feature-flags')
    return response.data
  }
} 